import React, { useCallback, useState } from 'react';
import { UsersIcon, CheckCircle2Icon, MousePointerClickIcon, ListChecksIcon, AlertTriangleIcon, SmartphoneIcon, RefreshCwIcon, Trash2Icon } from 'lucide-react';
import { getAllSessions, computeAnalytics, clearAllSessions } from '../data/analyticsStore';
import { MetricCard } from '../components/dashboard/MetricCard';
import { FunnelChart } from '../components/dashboard/FunnelChart';
import { QuestionBreakdown } from '../components/dashboard/QuestionBreakdown';
import { ResultDistribution } from '../components/dashboard/ResultDistribution';
export function Dashboard() {
  const [refreshKey, setRefreshKey] = useState(0);
  const sessions = getAllSessions();
  const analytics = computeAnalytics(sessions);
  const handleRefresh = useCallback(() => {
    setRefreshKey(k => k + 1);
  }, []);
  const handleClear = useCallback(() => {
    if (window.confirm('¿Borrar todos los datos de analytics? Esta acción no se puede deshacer.')) {
      clearAllSessions();
      setRefreshKey(k => k + 1);
    }
  }, []);
  const isEmpty = analytics.totalSessions === 0;
  return <div className="min-h-screen bg-[#0a0a0f] px-4 py-6 md:px-8 md:py-10" data-id="element-387">
      <div className="mx-auto max-w-6xl" data-id="element-388">
        {/* Header */}
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between mb-8" data-id="element-389">
          <div data-id="element-390">
            <h1 className="font-body text-xl font-bold text-white md:text-2xl" data-id="element-391">
              Quiz Analytics
            </h1>
            <p className="font-body text-sm text-white/40 mt-1" data-id="element-392">
              {analytics.totalSessions} sesiones registradas
            </p>
          </div>
          <div className="flex items-center gap-2" data-id="element-393">
            <button onClick={handleRefresh} className="inline-flex items-center gap-1.5 rounded-lg border border-white/10 bg-white/[0.06] px-3 py-2 font-body text-xs text-white/70 transition-colors hover:bg-white/[0.1]" data-id="element-394">
              <RefreshCwIcon className="h-3.5 w-3.5" data-id="element-395" />
              Actualizar
            </button>
            <button onClick={handleClear} className="inline-flex items-center gap-1.5 rounded-lg border border-red-500/20 bg-red-500/5 px-3 py-2 font-body text-xs text-red-400/80 transition-colors hover:bg-red-500/10" data-id="element-396">
              <Trash2Icon className="h-3.5 w-3.5" data-id="element-397" />
              Limpiar
            </button>
          </div>
        </div>

        {isEmpty ? <div className="flex flex-col items-center justify-center py-32 text-center" data-id="element-398">
            <div className="rounded-full bg-white/[0.04] p-6 mb-4" data-id="element-399">
              <UsersIcon className="h-10 w-10 text-white/20" data-id="element-400" />
            </div>
            <h2 className="font-body text-lg font-semibold text-white/60" data-id="element-401">
              Sin datos todavía
            </h2>
            <p className="font-body text-sm text-white/30 mt-2 max-w-sm" data-id="element-402">
              Cuando los visitantes completen el quiz, los datos aparecerán aquí
              automáticamente.
            </p>
          </div> : <>
            {/* Metric Cards */}
            <div className="grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-6 mb-6" data-id="element-403">
              <MetricCard label="Visitantes" value={analytics.uniqueVisitors} icon={UsersIcon} subtitle="únicos" data-id="element-404" />
              <MetricCard label="Completado" value={`${analytics.completionRate.toFixed(1)}%`} icon={CheckCircle2Icon} trend={analytics.completionRate > 50 ? 'up' : analytics.completionRate > 20 ? 'neutral' : 'down'} trendValue={`${analytics.completionRate.toFixed(0)}%`} data-id="element-405" />
              <MetricCard label="CTA Click" value={`${analytics.ctaClickRate.toFixed(1)}%`} icon={MousePointerClickIcon} trend={analytics.ctaClickRate > 30 ? 'up' : analytics.ctaClickRate > 10 ? 'neutral' : 'down'} trendValue={`${analytics.ctaClickRate.toFixed(0)}%`} data-id="element-406" />
              <MetricCard label="Avg Preguntas" value={analytics.avgQuestionsAnswered.toFixed(1)} icon={ListChecksIcon} subtitle="de 14" data-id="element-407" />
              <MetricCard label="Mayor Caída" value={analytics.biggestDropStep} icon={AlertTriangleIcon} subtitle={`-${analytics.biggestDropPercent.toFixed(0)}%`} trend="down" trendValue={`${analytics.biggestDropPercent.toFixed(0)}%`} data-id="element-408" />
              <MetricCard label="Dispositivo" value={`${analytics.deviceSplit.mobile}%`} icon={SmartphoneIcon} subtitle={`móvil / ${analytics.deviceSplit.desktop}% desktop`} data-id="element-409" />
            </div>

            {/* Funnel Chart */}
            <div className="mb-6" data-id="element-410">
              <FunnelChart data={analytics.funnel} data-id="element-411" />
            </div>

            {/* Two Column: Question Breakdown + Result Distribution */}
            <div className="grid grid-cols-1 gap-6 lg:grid-cols-2" data-id="element-412">
              <QuestionBreakdown data={analytics.questionBreakdowns} data-id="element-413" />
              <ResultDistribution data={analytics.resultDistribution} data-id="element-414" />
            </div>
          </>}
      </div>
    </div>;
}